<template>
  <f7-page
    :theme-dark="dark"
    id="welcome">
    <f7-swiper
      class="welcome-swiper"
      pagination>
      <f7-swiper-slide>
        <div class="welcome-slide">
          <div class="welcome-img welcome-geo">
            <div class="satellite">
              <FlatIcon
                name="satellite"
                :size="40"
              />
            </div>
            <div class="earth">
              <img src="../../assets/images/520660862.jpg">
            </div>
          </div>
          <div class="welcome-text">
            <p>{{ t('welcomeGeoTxt') }}</p>
            <p>
              <f7-button
                fill
                :disabled="geoLoading"
                @click="enableGeolocation">
                {{ t('welcomeGeoBtn') }}
              </f7-button>
            </p>
            <p>
              <f7-button @click="next">
                {{ t('skip') }}
              </f7-button>
            </p>
          </div>
        </div>
      </f7-swiper-slide>
      <f7-swiper-slide>
        <div class="welcome-slide">
          <div class="welcome-img welcome-sleep">
            <div class="sleep-1">
              <img src="../../assets/images/476212230-1.png">
            </div>
            <div class="sleep-2">
              <img src="../../assets/images/476212230-2.png">
            </div>
          </div>
          <div class="welcome-text">
            <p>{{ t('welcomeUxTxt') }}</p>
            <p>
              <f7-button
                fill
                @click="enableInsomnia">
                {{ t('welcomeUxBtn') }}
              </f7-button>
            </p>
            <p>
              <f7-button @click="next">
                {{ t('skip') }}
              </f7-button>
            </p>
          </div>
        </div>
      </f7-swiper-slide>
      <f7-swiper-slide>
        <div class="welcome-slide">
          <div class="welcome-img welcome-legal">
            <img src="../../assets/images/655450338.jpg">
            <f7-preloader v-if="loading" />
          </div>
          <div class="welcome-text welcome-text-legal">
            <p>{{ t('welcomeGtuTxt') }}</p>
            <p>
              <f7-button
                fill
                :disabled="loading"
                @click="getTerms">
                {{ t('welcomeGtuBtn') }}
              </f7-button>
            </p>
          </div>
        </div>
      </f7-swiper-slide>

      <TermsOfUse
        v-if="showTerms"
        @loading="setLoading"
        @close="$f7router.navigate('/', { clearHistory: true })" />
    </f7-swiper>
  </f7-page>
</template>

<script>
import TermsOfUse from '@/components/io/TermsOfUse'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Welcome',
  components: {
    TermsOfUse
  },
  data () {
    return {
      showTerms: false,
      loading: false,
      err: null
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting',
      geoLoading: 'global/geoLoading',
      lang: 'global/lang'
    })
  },
  methods: {
    ...mapActions({
      setSetting: 'global/setSetting',
      geoStart: 'global/geoStart'
    }),
    setLoading (bool) {
      this.loading = bool
    },
    enableGeolocation () {
      this.geoStart().then(() => {
        this.next()
      })
    },
    enableInsomnia () {
      if (window.plugins && window.plugins.insomnia) window.plugins.insomnia.keepAwake()
      this.setSetting({ nosleep: true })
      this.next()
    },
    getTerms () {
      this.showTerms = true
    },
    next () {
      const swiper = this.$f7.swiper.get('.welcome-swiper')
      swiper.slideNext()
    }
  }
}
</script>

<style lang="scss">
.welcome-swiper {
  height: 100%;
  background: white;
  .swiper-pagination-bullets {
    bottom: 30px;
  }
}
.welcome-slide {
  display: flex;
  height: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  max-width: 480px;
  flex-direction: column;
  margin: auto;
  text-align: center;
  padding: 20px;
}
.welcome-img {
  margin: auto;
}
.welcome-text {
  max-width: 280px;
  margin: auto;
  z-index: 2;
  p {
    margin-bottom: 30px;
  }
}
.welcome-geo {
  box-sizing: border-box;
  position: relative;
  .earth {
    padding: 40px;
    transform-origin: 50% 50%;
    animation: rotating 60s linear reverse infinite;
    img {
      width: 100%;
      height: auto;
    }
  }
  .satellite {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    transform-origin: 50% 50%;
    animation: rotating 20s linear infinite;
    .picto-satellite {
      transform: rotate(-45deg);
    }
  }
}
.welcome-sleep {
  text-align: center;
  .sleep-1,
  .sleep-2 {
    width: 35%;
    display: inline-block;
    vertical-align: bottom;
    animation: shake-slow;
    animation-duration: 60s;
    animation-iteration-count: infinite;
    img {
      width: 100%;
      height: auto;
    }
  }
  .sleep-2 {
    animation-duration: 50s;
  }
}
.welcome-legal {
  padding: 70px;
  img {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
  }
}
.welcome-text-legal {
  padding-bottom: 58px;
}
</style>

<docs>
```js
<Welcome />
```
</docs>
